import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Image, Header, Card, Segment, Statistic, Grid } from "semantic-ui-react";
import Cookie from "react-cookies";
import Container from "../../components/Container/Container";
import styles from "./InvestorReportScreen.module.css";


import { fetchInvestorReport } from "../../redux/actions/user";

const InvestorReportScreen = ({ user, reportData, fetchInvestorReport }) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadReport = async () => {
            setLoading(true);
            try {
                const userId = await Cookie.load("userId");
                await fetchInvestorReport(userId);
            } catch (error) {
                console.error("Error loading report", error);
            }
            setLoading(false);
        };

        loadReport();
    }, [fetchInvestorReport]);

    const {
        totalRecharge = 0,
        totalRetrait = 0,
        beneficesNets = 0,
        budgetCompagnie = 0,
        profitsAssocies = 0,
        mesProfits = 0
    } = reportData || {};

    const userPercentage = user?.profile?.percentage || user?.profile?.pourcentage || 0;

    return (
        <Container title="Rapport d'investissement">
            <div className={styles.container}>

                <div className={styles.logoContainer}>
                    <Image src={"/logo3_1.png"} className={styles.logo} />
                    <Header as="h2" textAlign="center" className={styles.title}>
                        Rapport des Investisseurs
                    </Header>
                </div>

                <Segment loading={loading} className={styles.reportSegment}>
                    <Grid columns={1} stackable>
                        <Grid.Column>
                            <Card fluid className={styles.cardStyle}>
                                <Card.Content>
                                    <Card.Header>Récapitulatif Global</Card.Header>
                                    <Card.Description>
                                        <Statistic.Group size="small" horizontal className={styles.statGroup}>
                                            <Statistic>
                                                <Statistic.Value>{totalRecharge?.toLocaleString()} Gdes</Statistic.Value>
                                                <Statistic.Label>Total Recharge</Statistic.Label>
                                            </Statistic>
                                            <Statistic>
                                                <Statistic.Value color="red">{totalRetrait?.toLocaleString()} Gdes</Statistic.Value>
                                                <Statistic.Label>Total Retrait</Statistic.Label>
                                            </Statistic>
                                            <Statistic>
                                                <Statistic.Value color="green">{beneficesNets?.toLocaleString()} Gdes</Statistic.Value>
                                                <Statistic.Label>Bénéfices Nets</Statistic.Label>
                                            </Statistic>
                                        </Statistic.Group>
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                        </Grid.Column>

                        <Grid.Column>
                            <Card fluid className={styles.cardStyle}>
                                <Card.Content>
                                    <Card.Header>Répartition des Bénéfices</Card.Header>
                                    <Card.Description>
                                        <Statistic.Group size="small" horizontal className={styles.statGroup}>
                                            <Statistic>
                                                <Statistic.Value color="orange">{budgetCompagnie?.toLocaleString()} Gdes</Statistic.Value>
                                                <Statistic.Label>Budget Compagnie (-40%)</Statistic.Label>
                                            </Statistic>
                                            <Statistic>
                                                <Statistic.Value color="blue">{profitsAssocies?.toLocaleString()} Gdes</Statistic.Value>
                                                <Statistic.Label>Profits des Associés (60%)</Statistic.Label>
                                            </Statistic>
                                        </Statistic.Group>
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                        </Grid.Column>

                        {userPercentage > 0 && (
                            <Grid.Column>
                                <Card fluid className={styles.cardStyle}>
                                    <Card.Content>
                                        <Card.Header>Mes Profits</Card.Header>
                                        <Card.Description>
                                            <Statistic.Group size="small" horizontal className={styles.statGroup}>
                                                <Statistic>
                                                    <Statistic.Value color="teal">{mesProfits?.toLocaleString()} Gdes</Statistic.Value>
                                                    <Statistic.Label>Basé sur votre part de {userPercentage}%</Statistic.Label>
                                                </Statistic>
                                            </Statistic.Group>
                                        </Card.Description>
                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                        )}
                    </Grid>
                </Segment>
            </div>
        </Container>
    );
};

const mapStateToProps = (state) => ({
    user: state.user,
    reportData: state.user.investorReport
});

const mapDispatchToProps = {
    fetchInvestorReport
};

export default connect(mapStateToProps, mapDispatchToProps)(InvestorReportScreen);
